export const onlyNumbers = (e) => {
    const value = e.target.value;
    // Permitir números, puntos, y comas, y evitar letras
    if (/^[0-9.,]*$/.test(value)) {
        e.target.value = value;
    } else {
        e.preventDefault(); // Evita que se ingresen caracteres no deseados, como letras
    }
};
